import { ref } from 'vue';

const worktimesHandler = () => {
  const worktimes_error = ref(null);
  const allWorktimes = ref(null);

  const loadAllWorktimes = async () => {
    try {
      let data = await fetch("/api/worktimes");

      if (!data.ok) {
        throw Error("Can't load data");
      }

      allWorktimes.value = await data.json();

      //console.log('projects', projects.value);
    } catch (err) {
      worktimes_error.value = err.message;
    }
  }

  return { allWorktimes, worktimes_error, loadAllWorktimes };
};

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

export default worktimesHandler;
